
<div class="tw-flex tw-flex-col tw-h-full tw-w-full tw-p-2 tw-rounded-2xl 
    tw-bg-[var(--sys-card)] tw-border tw-border-[var(--sys-divider)] tw-box-border
    tw-shadow-lg"
>
    @if(showSidebarHeader) {
        <div class="tw-px-3 tw-flex tw-justify-between tw-items-center tw-border-b tw-border-[var(--sys-divider)]">
            <div class="tw-text-sm tw-font-bold">
                <ng-content select="[sidebarTitle]"></ng-content>
            </div>
            <div class="tw-flex tw-gap-1">
                <ng-content select="[sidebarActions]"></ng-content>
            </div>
        </div>
    }

    <div [class.tw-py-2]="!showSidebarHeader" class="tw-flex-1 tw-overflow-y-auto" id="sidebarContent">
        <ng-content select="[sidebar]"></ng-content>
    </div>
</div>